<template>
<div>
   <div>
    <table class="timesheet-quick-table">
        <tbody>
            <tr class="quick-header">
                <td class="td-first-el">
                    <div class="quick-timesheet-hours-lables" style="width:40px">
                        <div class="quick-timesheet-rt-lables">

                        </div>
                    </div>
                </td>
                <td class="td_style" v-for="(item,index) in WeekDays" :key="index">
                    <template>
                        <div class="td_week_header">{{item}}
                           <i v-if="!IsWeekDay(item) && !IsEmployer" v-tooltip="{ content: toolTipContent }" data-v-2110712a="" aria-hidden="true" class="fa fa-question" style="
                                background-color: #88A9D7;
                                color: white;
                                padding: 2px 4px;
                                border-radius: 8px;
                                font-size: 10px;
                            "></i>
                        </div>
                    </template>
                </td>
            </tr>
            <tr v-for="(item, trIndex) in this.QuickTimesheetList" class="quick-table-body"  v-bind:key="trIndex">
                <td class="td_style">
                    <div>
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <span class="quick-timesheet-lables-header">
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span class="quick-timesheet-rt-lables">
                                          RT
                                        </span>
                                        <span class="validation-star">*</span>
                                    </td>
                                </tr>
                                <tr v-if="IsOverTimeApplicable">
                                    <td>
                                        <span class="quick-timesheet-ot-lables">
                                          OT
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </td>
                <td class="td_style" v-for="(h, tdIndex) in item" :key="tdIndex">
                    <template>
                        <!-- <div class="td-date-cell " :class="{ 'date-disable':h.isDisabled || !h.IsWeekDay || (!AllowTimeSheetSubmissionOnHolidays && (h.DayType == 'FederalHoliday' || h.DayType == 'Holiday'))}"> -->
                          <div class="td-date-cell" :class="{ 'date-disable': h.isDisabled || !h.IsWeekDay || (!AllowTimeSheetSubmissionOnHolidays && (h.DayType == 'FederalHoliday' || h.DayType == 'Holiday')) || (!AllowTimeSheetSubmissionOnLeaves && (h.DayType == 'Leave'))}">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <span class="td_date_span">
                                                {{ getDateFormat(h.Date) }}
                                                <!-- Check if DayType is 'Leave' and IsWeekDay is true, then display 'On Leave' -->
                                                <span v-if="h.DayType === 'Leave'" class="leave-tag"> &nbsp;(On Leave)</span>
                                            </span>
                                        </td>
                                    </tr>
                                    <tr class="quick-timesheet-rt">
                                        <td>
                                          <div class="select2_div">
                                            <ob-input v-if="h.show" :disabled="h.isDisabled || !h.IsWeekDay || (!AllowTimeSheetSubmissionOnHolidays && (h.DayType == 'FederalHoliday' || h.DayType == 'Holiday')) || (!AllowTimeSheetSubmissionOnLeaves && (h.DayType == 'Leave'))" :maxLength="2" v-number-only placeholder="hrs" v-model="h.tasksList.Hours" class="select2_style" :class="{ 'ob-vuelidate_input-error': totalHoursvalidation(h,h.tasksList.Hours) || RThoursValidation(h) || compareMaxHours(h.tasksList.Hours,h.tasksList.Minutes,h.tasksList,h.tasksList.Hours) }"></ob-input>
                                            <ob-input v-if="h.show" :disabled="h.isDisabled || !h.IsWeekDay || (!AllowTimeSheetSubmissionOnHolidays && (h.DayType == 'FederalHoliday' || h.DayType == 'Holiday')) || (!AllowTimeSheetSubmissionOnLeaves && (h.DayType == 'Leave'))" :maxLength="2" v-number-only placeholder="mins" v-model="h.tasksList.Minutes" class="select2_style" :class="{ 'ob-vuelidate_input-error': totalHoursvalidation(h,h.tasksList.Minutes) || RThoursValidation(h) || (parseInt(h.tasksList.Minutes) > 59) || compareMaxHours(h.tasksList.Hours,h.tasksList.Minutes,h.tasksList,h.tasksList.Minutes) }"></ob-input>
                                        </div>
                                        </td>
                                    </tr>
                                    <tr v-if="IsOverTimeApplicable" class="quick-timesheet-ot">
                                        <td>
                                          <div class="select2_div">
                                            <ob-input v-if="h.show" :disabled="h.isDisabled || !h.IsWeekDay || (!AllowTimeSheetSubmissionOnHolidays && (h.DayType == 'FederalHoliday' || h.DayType == 'Holiday')) || (!AllowTimeSheetSubmissionOnLeaves && (h.DayType == 'Leave'))" :maxLength="2" v-number-only placeholder="hrs" v-model="h.tasksList.OverTimeHours" class="select2_style" :class="{ 'ob-vuelidate_input-error': totalHoursvalidation(h,h.tasksList.OverTimeHours) }"></ob-input>
                                            <ob-input v-if="h.show" :disabled="h.isDisabled || !h.IsWeekDay || (!AllowTimeSheetSubmissionOnHolidays && (h.DayType == 'FederalHoliday' || h.DayType == 'Holiday')) || (!AllowTimeSheetSubmissionOnLeaves && (h.DayType == 'Leave'))" :maxLength="2" v-number-only placeholder="mins" v-model="h.tasksList.OverTimeMinutes" class="select2_style" :class="{ 'ob-vuelidate_input-error': totalHoursvalidation(h,h.tasksList.OverTimeMinutes) || (parseInt(h.tasksList.Minutes) > 59) }"></ob-input>
                                         </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                    </template>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div v-if="isMaxHoursValid" style="padding-bottom:5px;">
  <span v-if="IsPreviousRTHoursvalid" class="ob-vuelidate_error-msg">
    As there are previously added timesheet(s) for certain days, on which the total regular time exceeds {{MaximumRegulerTimesheetHours}} hours. Please verify
  </span>
  <span v-else class="ob-vuelidate_error-msg">Please enter valid hours. Your employer has set the maximum regular time hour limit to {{MaximumRegulerTimesheetHours}} hours per day.</span>
</div>
<div v-else-if="isHoursValid">
  <span class="ob-vuelidate_error-msg">The total work time cannot be more than 24 hours per day.</span>
</div>
</div>
</template>
<script>
import c from "Vue/Core/constants.js";
import utils from "Vue/Core/utils.js";
// import AddTask from "./AddTask.vue";
import {
  required,
  minLength,
  maxLength,
  requiredIf,
  email,
  alpha,
  minValue,
  maxValue
} from "vuelidate/lib/validators";
export default {
  props: {
    WorkSheets: {
      type: Array,
      required: true
    },
    IsOverTimeApplicable:
    {
      type: Boolean,
      required: true
    },
    PreviousWorkHours: {
     type: Array,
      required: true
    },
    MaximumRegulerTimesheetHours:{
      type:Number,
      required: true
    },
    AllowTimeSheetSubmissionOnHolidays:{
      type: Boolean,
      required: true
    },
    AllowTimeSheetSubmissionOnLeaves:{
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      WorkItems:[],
      WeekDays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      DateList: [],
      aa: {},
      isHoursValid : false,
      isButtonClicked:false,
      isMaxHoursValid:false,
      IsPreviousRTHoursvalid:false,
    };
  },
  watch:
  {
    QuickTimesheetList:{
      handler: function (val, oldVal) {
        this.TotalHoursWorked();
      },
      deep: true
    }
  },
  created() {
    this.TotalHoursWorked();
  },
  computed: {
    IsEmployer()
    {
      return this.$route.name == 'employer-timesheets'
    },
    QuickTimesheetList()
    {
      return this.WorkSheets
    },
    IsValid()
    {
      this.isButtonClicked = true;
      return this.isHoursValid || this.isMaxHoursValid;
    },
     weekendsList()
    { 
        var str = [];
        var parent = this.IsEmployer ? this.$parent.$parent : this.$parent.$parent.$parent;
        if(!parent.IsSunday)
        {
            str.push('Sunday')
        }
          if(!parent.IsMonday)
        {
            str.push('Monday')
        } 
        if(!parent.IsTuesday)
        {
            str.push('Tuesday')
        } 
        if(!parent.IsWednesday)
        {
            str.push('Wednesday')
        } 
        if(!parent.IsThursday)
        {
            str.push('Thursday')
        }
        if(!parent.IsFriday)
        {
            str.push('Friday')
        }
        if(!parent.IsSaturday)
        {
            str.push('Saturday')
        }
        return str.join(' and ')
    },
    toolTipContent()
    {
       return `You can’t add timesheets for ${this.weekendsList} as per your organization(${this.loggedInUserObj.OrgName}) settings. You can reach out to your HR for more information`;
    },
  },
  methods: {
   IsWeekDay(day)
    { 
        var parent = this.IsEmployer ? this.$parent.$parent : this.$parent.$parent.$parent;
       if(day == 'Sunday' && parent.IsSunday)
       {
         return true;
       }
       else if(day == 'Monday' && parent.IsMonday)
       {
         return true;
       }
       else if(day == 'Tuesday' && parent.IsTuesday)
       {
         return true;
       } 
       else if(day == 'Wednesday' && parent.IsWednesday)
       {
         return true;
       } 
       else if(day == 'Thursday' && parent.IsThursday)
       {
         return true;
       } 
       else if(day == 'Friday' && parent.IsFriday)
       {
         return true;
       } 
       else if(day == 'Saturday' && parent.IsSaturday)
       {
         return true;
       }
       return false;
    },
    minsAutoFill(regularMin,overtimeMins)
    { 
      if(this.AllowTimeSheetSubmissionOnHolidays){
        var tempArray = [].concat.apply([], this.QuickTimesheetList).filter(v=>v.IsWeekDay && !v.isDisabled);
      }
      else{
        var tempArray = [].concat.apply([], this.QuickTimesheetList).filter(v=>v.IsWeekDay && !v.isDisabled && v.DayType != 'FederalHoliday' && v.DayType != 'Holiday');
      }
       var parent = this.IsEmployer ? this.$parent.$parent : this.$parent.$parent.$parent;
      if(parent.IsWeekendChecked)
      {
      tempArray = [].concat.apply([], this.QuickTimesheetList).filter(v=>!this.IsSatAndSunday(v.Date) && !v.isDisabled);
      }
      if(!this.AllowTimeSheetSubmissionOnLeaves)
      {
        tempArray = [].concat.apply([], tempArray).filter(v=>v.IsWeekDay && !v.isDisabled && v.DayType != 'Leave');
      }

      var totalRegularMinutesPerDay = regularMin/tempArray.length;
      var RegHoursPerday = Math.floor(totalRegularMinutesPerDay / 60);  
      var RegMinutesPerDay = parseInt(totalRegularMinutesPerDay % 60);

      var totalOverMinutesPerDay = overtimeMins/tempArray.length;
      var OverHoursPerday = Math.floor(totalOverMinutesPerDay / 60);  
      var OverMinutesPerDay = parseInt(totalOverMinutesPerDay % 60);


       for(var a  = 0 ; a < this.QuickTimesheetList.length ; a++)
      {
        for(var b  = 0 ; b < this.QuickTimesheetList[a].length ; b++)
        {
           var parent = this.IsEmployer ? this.$parent.$parent : this.$parent.$parent.$parent;
          if(parent.IsWeekendChecked)
          {
             if(this.QuickTimesheetList[a][b].isDisabled == false && !this.IsSatAndSunday(this.QuickTimesheetList[a][b].Date)){
              this.QuickTimesheetList[a][b].tasksList.Hours = RegHoursPerday.toString();
              this.QuickTimesheetList[a][b].tasksList.Minutes = RegMinutesPerDay.toString();

              this.QuickTimesheetList[a][b].tasksList.OverTimeHours = OverHoursPerday.toString();
              this.QuickTimesheetList[a][b].tasksList.OverTimeMinutes = OverMinutesPerDay.toString();
            }
            else{
              this.QuickTimesheetList[a][b].tasksList.Hours = "0"
              this.QuickTimesheetList[a][b].tasksList.Minutes = "0"

              this.QuickTimesheetList[a][b].tasksList.OverTimeHours = "0"
              this.QuickTimesheetList[a][b].tasksList.OverTimeMinutes = "0"
            }
          }
          else
          {
            if(this.QuickTimesheetList[a][b].isDisabled == false && this.QuickTimesheetList[a][b].IsWeekDay &&(!this.AllowTimeSheetSubmissionOnHolidays && (this.QuickTimesheetList[a][b].DayType == 'FederalHoliday' || this.QuickTimesheetList[a][b].DayType == 'Holiday'))){
              this.QuickTimesheetList[a][b].tasksList.Hours = "0"
              this.QuickTimesheetList[a][b].tasksList.Minutes = "0"

              this.QuickTimesheetList[a][b].tasksList.OverTimeHours = "0"
              this.QuickTimesheetList[a][b].tasksList.OverTimeMinutes = "0"
            }
            else if(this.QuickTimesheetList[a][b].isDisabled == false && this.QuickTimesheetList[a][b].IsWeekDay && (!this.AllowTimeSheetSubmissionOnLeaves && (this.QuickTimesheetList[a][b].DayType == 'Leave'))){
              this.QuickTimesheetList[a][b].tasksList.Hours = "0"
              this.QuickTimesheetList[a][b].tasksList.Minutes = "0"
              this.QuickTimesheetList[a][b].tasksList.OverTimeHours = "0"
              this.QuickTimesheetList[a][b].tasksList.OverTimeMinutes = "0"
            }
            else {
              if(this.QuickTimesheetList[a][b].isDisabled == false && this.QuickTimesheetList[a][b].IsWeekDay){
              this.QuickTimesheetList[a][b].tasksList.Hours = RegHoursPerday.toString();
              this.QuickTimesheetList[a][b].tasksList.Minutes = RegMinutesPerDay.toString();

              this.QuickTimesheetList[a][b].tasksList.OverTimeHours = OverHoursPerday.toString();
              this.QuickTimesheetList[a][b].tasksList.OverTimeMinutes = OverMinutesPerDay.toString();
              }
              else{
              this.QuickTimesheetList[a][b].tasksList.Hours = "0"
              this.QuickTimesheetList[a][b].tasksList.Minutes = "0"

              this.QuickTimesheetList[a][b].tasksList.OverTimeHours = "0"
              this.QuickTimesheetList[a][b].tasksList.OverTimeMinutes = "0"
             }
            }
          }
        }
      }     
    },
    IsSatAndSunday(date)
    {
      var day = moment(date).format('dddd');
       if(day == 'Sunday')
       {
         return true;
       }
       else if(day == 'Saturday')
       {
         return true;
       }
       return false;
    },
    // 24 hours validation
    totalHoursvalidation(worksheets,val)
    {
      var time= worksheets.totalTime;

      if(time != undefined && time != null && val != null && val != undefined)
      {

        var x = time.split(' ');
        var h = parseInt(val);
        let hrs = 0;
        let min = 0;
        if(x[0] != null && x[0] != undefined)
        {
          hrs = parseInt(x[0].replace("h ",""));
        }
        if(x[1] != null && x[1] != undefined) 
        {
          min  = parseInt(x[1].replace("m",""))
        }

        if(hrs > 24 && h>0 )
        {
          return true
        }
        else if(hrs == 24 && min > 0 && h > 0)
        {
          return true
        }
        else return false
      }
    },
    IsPreviousRTHoursExist(worksheets){
      var time= worksheets.totalTime;
      if(time != undefined && time != null)
      {
        var previousWorkHours = this.PreviousWorkHours.find(v=>v.Date == worksheets.Date) ? this.PreviousWorkHours.find(v=>v.Date == worksheets.Date).RegularHours : "0h";   
        if(previousWorkHours == '0h')
        {
          return false;
        }
        var y = previousWorkHours.split(' ');
        let preHrs = y[0] ? parseInt(y[0].replace("h ","")):"0";
        let preMin = y[1] ? parseInt(y[1].replace("m","")):"0";

        var x = time.split(' ');
        let hrs = 0;
        let min = 0;
        if(x[0] != null && x[0] != undefined)
        {
          hrs = parseInt(x[0].replace("h ","")) + preHrs
        }
        if(x[1] != null && x[1] != undefined)
        {
          min  = parseInt(x[1].replace("m","")) + preMin
        }
        if(hrs > this.MaximumRegulerTimesheetHours)
        {
          return true
        }
        else if(hrs == this.MaximumRegulerTimesheetHours && min > 0)
        {
          return true
        }
        else return false
      }
    },
    // Total hours worked for all days
    TotalHoursWorked()
    {
      let hrs = 0 ;
      let min = 0 ;
      let OThrs = 0 ;
      let OTmin = 0 ;
      this.isHoursValid = false;
       this.isMaxHoursValid = false;
       this.IsPreviousRTHoursvalid = false;
      for(var a  = 0 ; a < this.QuickTimesheetList.length ; a++)
      {
        var item = this.QuickTimesheetList[a];
        for(var b  = 0 ; b < item.length ; b++)
        {
          let x = item[b];
          if(!x.isDisabled && ((this.AllowTimeSheetSubmissionOnHolidays)||(!this.AllowTimeSheetSubmissionOnHolidays && (x.DayType != 'FederalHoliday'|| x.DayType != 'Holiday'))))
          {
            let h = (parseInt(x.tasksList.Hours) || 0) + (parseInt(x.tasksList.OverTimeHours) || 0)
            let m =  (parseInt(x.tasksList.Minutes) || 0) +  (parseInt(x.tasksList.OverTimeMinutes) || 0)
            this.addTotalTime(a,b,h,m)
            hrs =  hrs + h;
            min = min + m;
            this.isHoursValid = this.isHoursValid || this.totalHoursvalidation(x,5);
            this.isMaxHoursValid = this.isMaxHoursValid || this.compareMaxHours(x.tasksList.Hours,x.tasksList.Minutes,x.tasksList,5)
            this.IsPreviousRTHoursvalid = this.IsPreviousRTHoursvalid || this.IsPreviousRTHoursExist(x)
          }
          else if(!x.isDisabled && (this.AllowTimeSheetSubmissionOnLeaves||(!this.AllowTimeSheetSubmissionOnLeaves && (x.DayType != 'Leave'))))
          {
            let h = (parseInt(x.tasksList.Hours) || 0) + (parseInt(x.tasksList.OverTimeHours) || 0)
            let m =  (parseInt(x.tasksList.Minutes) || 0) +  (parseInt(x.tasksList.OverTimeMinutes) || 0)
            this.addTotalTime(a,b,h,m)
            hrs =  hrs + h;
            min = min + m;
            this.isHoursValid = this.isHoursValid || this.totalHoursvalidation(x,5);
            this.isMaxHoursValid = this.isMaxHoursValid || this.compareMaxHours(x.tasksList.Hours,x.tasksList.Minutes,x.tasksList,5)
            this.IsPreviousRTHoursvalid = this.IsPreviousRTHoursExist(x) || this.IsPreviousRTHoursvalid
          }
        }
      }
      let hours = (min / 60);
      let rhours = Math.floor(hours);
      let minutes = (hours - rhours) * 60;
      let rminutes = Math.round(minutes);
      let totalHours = parseInt(hrs) + parseInt(rhours)
      let _totalHoursWorked =  (parseInt(totalHours) || 0) +"h " + (parseInt(rminutes) + "m") || 0;
      this.$emit("totalHoursWorked",_totalHoursWorked) ;
    },

    // Total hours worked for single
    addTotalTime(a,b,h,m)
    {
      let hr = (m / 60);
      let rhr = Math.floor(hr);
      let min = (hr - rhr) * 60;
      let rmin = Math.round(min);
      let totalHr = (parseInt(h) || 0) + (parseInt(rhr) || 0);
      let i = totalHr +"h " + rmin + "m";
      this.QuickTimesheetList[a][b].totalTime = i;
    },
    getDateFormat(date) {
      var date1 = moment(date).format("Do");
      var month = moment(date).format("MMM");
      return date1 + " " + month;
    },
    compareMaxHours(hrs1,min1,worksheet,val){
       var hrs = 0 ;
      var min = 0;
      var islimit='';
      if(hrs1 != ''){
        hrs=hrs+parseInt(hrs1)
      }
      if(min1 != ''){
        min=min+parseInt(min1)
      }
      var h = parseInt(val);
      var previousRTWorkHours = this.PreviousWorkHours.find(v=>v.Date == worksheet.Date) ? this.PreviousWorkHours.find(v=>v.Date == worksheet.Date).RegularHours : "0h";
        var y = previousRTWorkHours.split(' ');
        let preHrs = 0;
        let preMin = 0;
        if(y.length == 2){
          preHrs = y[0] ? parseInt(y[0].replace("h ","")):"0";
          preMin = y[1] ? parseInt(y[1].replace("m","")):"0";
        }
        else if(y.length == 1){
          if (y[0].includes('h')) {
            preHrs = preHrs + (parseInt(y[0].replace('h', '')) || 0);
				  }
          else if (y[0].includes('m')) {
            preMin = preMin + (parseInt(y[0].replace('h', '')) || 0);
				  }
				}
        hrs = hrs + parseInt(preHrs);
        min  = min + parseInt(preMin);
        var hours = (min / 60);
        var rhours = Math.floor(hours);
       var minutes = (hours - rhours) * 60;
       var rminutes = Math.round(minutes);
       var totalHours = parseInt(hrs) + parseInt(rhours);
       if(this.MaximumRegulerTimesheetHours==0){
         islimit=false
       }
       else if(totalHours == this.MaximumRegulerTimesheetHours && rminutes > 0 && h > 0){
          islimit=true
       }
       else if((totalHours > this.MaximumRegulerTimesheetHours) && h > 0){
        islimit=true
      }
      else {
         islimit=false
      }
      return islimit
    },
    RThoursValidation(worksheet){
      if(worksheet.tasksList.Hours == '' && worksheet.tasksList.Minutes == '' && worksheet.IsWeekDay && !worksheet.isDisabled && this.isButtonClicked){
        if(!this.AllowTimeSheetSubmissionOnHolidays && (worksheet.DayType == 'FederalHoliday' || worksheet.DayType == 'Holiday')){
          return false
        }
        else if(!this.AllowTimeSheetSubmissionOnLeaves && (worksheet.DayType == 'Leave')){
          return false
        }
        else{
          return true
        }
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.leave-tag{
  color: blue;
}
.td_week_header{
    margin: 10px 5px 10px 1px;
    white-space: nowrap;
    font-size: 16px;
    font-weight: 600;
     color:#000
}
.td_date_span{
    font-size: 11px;
    margin-bottom: 10px;
    display: inline-block;
    font-weight: 600;
}
.timesheet-quick-table
{
  width: 100%;
  .quick-table-body:not(:last-child){
        border-bottom: 1.5px dashed #d4cccc;
  };
}
.quick-header {
  background-color: #f8f8f8;
}
.quick-week-header {
  display: inline-block;
  margin: 10px 80px 10px 10px;
}
.day-name {
  font-size: 15px;
  font-weight: 700;
}
.td-date-cell {
  margin: 10px 5px 10px 1px;
  white-space: nowrap;
}
.date-disable {
  cursor: not-allowed !important;
  color: #00000057 !important;
}
.select2_style{
    margin: 1px -1px;
    display: inline-block;
    width: 50%;
}
.td_style{
   border: 5px;
   width:fit-content;
}
.td-first-el{
  width:fit-content;
}

.quick-timesheet-header-lables
{
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
    display: inline-block;

    //  margin-left: 10px;
     text-align: center;

}
.quick-timesheet-rt-lables{
   margin: 23px 0px 0px 0px;

   display: inline-block;
}
 .validation-star{
    color: #F31D1D;
  }
.quick-timesheet-ot-lables{
 margin: 15px 8px 0px 0px;
  display: inline-block;
}
.select2_div{
  width: 106px;
}
</style>
<style>

/* .select2-results__options::-webkit-scrollbar {
    width: 10px;
}
.select2-results__options::-webkit-scrollbar-thumb {

    -webkit-box-shadow: inset 0 0 6px#A8A8A8;
} */
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/QuickModeTimesheets.vue